import React from 'react';

const ExamStateContext = React.createContext({});
export default ExamStateContext;
